<template>
    <div class="container__top">    
        <!-- <Header :data="headerData" /> -->
        <div id="trails" class="container__main">
            <h2 class="title">
                {{pageTitle}}
            </h2>
            <h3 class="subtitle">
                Match your hiking <span>adventure</span> with your <span>wishes</span>!
            </h3>
            <div id="container-trail-filter" class="filter">
                <div class="filter__line">
                    <div class="filter__order">
                        <label class="filter__order--label">Order by</label>
                        <select name="filter-order" class="filter__select" v-model="orderBy">
                           <option v-for="option in sortingOptions" :key="option.val" :value="option.val">{{option.name}}</option>
                        </select>
                    </div>
                    
                </div>
                <div class="filter__line">
                    <search-trail :trails="trailsData.trails"></search-trail>
                    <div class="filter__actions">
                        
                        <button aria-label="display trail cards"  class="filter__line--item filter__button mousehover mousehover--bottom" :class="{'filter__button--selected' : displayTrail}" @click="toggleDisplay" data-hover="display trail cards">
                            <Svg className="filter__button--svg" icon="trail2"/>
                        </button>
                        <button  aria-label="display trail pictures"  class="filter__line--item filter__button mousehover mousehover--bottom" :class="{'filter__button--selected' : displayPictures}" @click="toggleDisplay" data-hover="display trail pictures">
                            <Svg className="filter__button--svg" icon="image"/>
                        </button>
                        <button  aria-label="search by location" class="filter__line--item filter__button  mousehover mousehover--bottom" :class="{'filter__button--selected' : displayMap}" data-hover="Find trails nearby a position" @click="toggleDisplayMap()">
                            <Svg className="filter__button--svg" icon="localisation"/>
                        </button>
                        <button  aria-label="search filters" class="filter__line--item filter__line--item-flex filter__filterbutton mousehover mousehover--bottom" :class="{'filter__filterbutton--selected': showFilterPanel}" @click="toggleFilterPanel" data-hover="Filters">
                            <Svg className="filter__filterbutton--svg" icon="param"/>
                            Filters
                        </button>
                    </div>

                </div>
               <filter-panel v-if="showFilterPanel" :data="trailsData" :filters="filtersData" @updateSearch="updateData" @updateFilter="updateFilters"></filter-panel>
            </div>
            <div class="filter__inline"> 
                <h3>Research filters :</h3>
                <ul>
                    <li v-for="filter in filterDisplay" :key="filter">{{filter}}</li>
                </ul>
            </div>
            <div>
                <search-map v-if="displayMap" :filters="filtersData" @updateFilter="updateData"></search-map>
            </div>
            <div v-if="displayTrail" class="trails">
                <trail-card v-for="trail in trails" :key="trail._id" :data="trail" :displayMap="displayMap"></trail-card>
            </div>
            <picture-gallery v-if="displayPictures" :gallery="pictures"></picture-gallery>
            <div v-if="displayTrail && displayLoadMore.trails" class="trails__load">
                <button class="btn btn--blue btn__spacing" @click="loadMore('trails')">
                    Load more
                </button>
            </div>
            <div v-else-if="displayPictures && displayLoadMore.pictures" class="trails__load">
                <button class="btn btn--blue btn__spacing" @click="loadMore('pictures')">
                    Load more
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {onMounted, ref, watch} from 'vue';
import Header from '../components/Header';
import Svg from '../components/utils/Svg';
import TrailCard from '../components/trails/TrailCard';
import Picture from '../components/pictures/Picture';

import FilterPanel from '../components/trails/FilterPanel';
import SearchTrail from '../components/trails/SearchTrail';

import PictureGallery from '../components/pictures/PictureGallery';
import SearchMap from '../components/SearchMap';

import axios from 'axios';
import moment from 'moment';

import { useRoute, useRouter } from 'vue-router';
import { sortOptions, trailsHeader } from '../composables/trails/data';

export default {
    components: {
        Header, 
        FilterPanel,

        Picture, 
        PictureGallery,
        SearchMap, 
        SearchTrail,
        Svg, 
        TrailCard
    },
    setup(){

        const displayLoadMore = ref({pictures:true, trails:true});
        const displayTrail = ref(true);
        const displayPictures = ref(!displayTrail);
        const showFilterPanel = ref(false);
        const displayMap = ref(true);
        
        
        const trails = ref([]);
        const pictures = ref([]);
        const gallery = ref([]);

        const route = useRoute();
        const router = useRouter();

        const trailsData = ref({});

        const page = ref({trails:1, pictures:1});

        const queryString = ref(null);

        const pageTitleDefault = 'Discover your next trail';
        const pageTitle = ref(pageTitleDefault)

        
        ///////////////////////////////////////////////////
        // INIT PAGE

        // Header
        const headerData = trailsHeader();

        

        // Filter Default
        const orderBy = ref('distanceFrom');
        let limitImages = 30;
        let limitTrails = 9;
        const filtersData = ref({
            minDuration: 1,
            maxDuration: 1000,
            when: [],
            country: [],
            continent: [],
            lat: 50.787933,
            lon: 4.375885
        });

        //Filters Data
        const sortingOptions = sortOptions();
        const filterDisplay=ref([`From ${filtersData.value.minDuration} to ${filtersData.value.maxDuration} days`]); 



        onMounted( () => {

            if(route.params.queryString){
                if(route.params.queryString === 'gallery') toggleDisplay()
                queryString.value = route.params.queryString;
                displayMap.value = false;
                toggleDisplayMap(false);
                
                orderBy.value = '-countLikes';
                displayMap.value = false;
            }

            getAllTrailsForSearch()
        });

        
        
        const watchOrderBy = watch(orderBy, (newVal, oldVal)=> {
            page.value = {trails:1, pictures:1};
            trailSearchData(limitTrails, orderBy.value, filtersData.value, page.value.trails);
        })

        

        const trailSearchData = async(limit, order, filters, page, query = '') => {
            try{
                
                const result = await axios({
                    method:"POST",
                    url:"trails/filter",
                    data:{
                        limit,
                        order,
                        filters,
                        page,
                        query
                    }
                });

                if(page === 1){
                    //On actualise les data trails
                    trails.value = result.data.data.data;

                    //On change le titre de la page
                    result.data.data.title ? pageTitle.value = result.data.data.title: pageTitle.value = pageTitleDefault

                    const query = result.data.data.query
                    //Update link
                    if(query){
                        if( !route.params.queryString || query !== route.params.queryString){
                            history.pushState(
                                {},
                                null,
                                '#/trails/'+query
                            )
                        }
                       
                    }

                    //Update filters
                    if(query != ''){
                        filtersData.value = result.data.data.filters;
                        updateFilters(result.data.data.filters)
                    }
                    
                }else{
                    result.data.data.data.forEach(trail=>{
                        trails.value.push(trail)
                    })
                }

                if(result.data.results < limit){
                    displayLoadMore.value.trails = false;
                }else{
                    displayLoadMore.value.Trails = true;
                }
                
            } catch(err){
                console.log(err);
                console.log(err.response);
            }
        }



        const updateFilters = (filters) => {
            filterDisplay.value=[`From 1 to ${filters.maxDuration} days`];
            if(filters.when.length) filterDisplay.value.push( 'Period : ' + filters.when.map(el=>moment(el, 'MMM').format('MM')).sort().map(el=>moment(el, 'MM').format('MMMM')).join(', '));
            if(filters.continent.length) filterDisplay.value.push('Continent : ' + filters.continent.sort().map(el=> trailsData.value.stats.continents.filter(item => item.iso === el)[0].name).join(', '));
            if(filters.country.length) filterDisplay.value.push('Country : ' + filters.country.sort().map(el=> trailsData.value.stats.countries.filter(item=>item.iso===el)[0].name).join(', '));
        };

        const updateData = (filters) => {
            updateFilters(filters);
            showFilterPanel.value = false;
            page.value = {trails:1, pictures:1};
            trailSearchData(limitTrails, orderBy.value, filters, page.value.trails);
            searchPictures('-countLikes');
        }

        const loadMore = (target) => {

            page.value[target]  += 1; 
            if(target === 'trails'){
                trailSearchData(limitTrails, orderBy.value, filtersData.value, page.value[target]);
            }

            if(target === 'pictures'){
                searchPictures('-countLikes');
            }   
        }

        const getAllTrailsForSearch = async () => {
            try{
                // GENERAL PAGE DATA
                const result = await axios({
                    method:"GET",
                    url: "trails/summary"
                })
                trailsData.value = result.data;
                filtersData.value.maxDuration = trailsData.value.stats.maxDuration;
                updateFilters(filtersData.value);

                //Filtered Trails
                if(displayTrail.value === true){
                    trailSearchData(limitTrails, orderBy.value, filtersData.value, page.value.trails, queryString.value)
                }

                if(displayPictures.value === true){
                    searchPictures('-countLikes');
                }
                
                
            }catch(err){
                console.log(err);
                console.log(err.response)
            }
        }



        const searchPictures = async (order) => {
            try{
                const result = await axios({
                    method:"POST",
                    url:"pictures/filter",
                    data:{
                        limit: limitImages,
                        order,
                        filters: filtersData.value,
                        page: page.value.pictures,
                        query: queryString.value
                    }
                });
                

                if(page.value.pictures === 1){
                    pictures.value = result.data.data.pictures;
                }else{
                    pictures.value.push(...result.data.data.pictures);
                }

                if(result.data.results < limitImages){
                    displayLoadMore.value.pictures = false;
                }else{
                    displayLoadMore.value.pictures = true;
                }

            } catch(err){
                console.log(err);
                console.log(err.response);
            }
            
        }

        const toggleDisplay = () => {
            displayTrail.value = !displayTrail.value;
            displayPictures.value = !displayPictures.value;
            displayPictures.value ? displayMap.value = false : displayMap.value = true;

            if(displayPictures.value){
                router.push({name:'Trails', params:{queryString:'gallery'}})
            }

            if(displayTrail.value){
                router.push({name:'Trails'})
            }

            
            if(! pictures.value.length) searchPictures('-countLikes');
        }

        const toggleFilterPanel = () => {
            showFilterPanel.value = !showFilterPanel.value;
        }

        const toggleDisplayMap = (newVal = '') => {
            if(!newVal){
                displayMap.value = !displayMap.value
            }else{
                displayMap.value = newVal
            }


            //Si classement par distance, on change le classement

            if(orderBy.value = 'distanceFrom' && !displayMap.value){
                orderBy.value = '-countLikes';
                displayMap.value = false;
            }else if(orderBy.value != 'distanceFrom' && displayMap.value){
                orderBy.value ='distanceFrom';
            }
            
        }


        return {
                displayLoadMore,
                displayMap,
                displayTrail, 
                displayPictures,
                filtersData,
                filterDisplay,
                gallery,
                headerData, 
                loadMore,
                orderBy,
                pageTitle,
                pictures,
                showFilterPanel,
                sortingOptions,
                toggleDisplay,
                toggleDisplayMap,
                toggleFilterPanel,
                trails,
                trailsData,
                updateData,
                updateFilters,
                watchOrderBy
        }
    }
}
</script>

<style lang="scss">

@import '@/style/main';
@import '@/style/components/filter.scss';

.trails{
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 4rem;

    &__load{
        display: flex;
        justify-content: center;
    }

}

</style>